import { Text, Truncated } from '@frontend/design-system';
import { AI_EVENT_BADGE_TYPE, getAiEventIcon } from '../icons/utils';

export type EventLabelConfig = {
  event: (typeof AI_EVENT_BADGE_TYPE)[keyof typeof AI_EVENT_BADGE_TYPE];
  text: string;
  order: number;
  isBold?: boolean;
  secondaryText?: string;
  reason?: string;
};

export const AiEventBadge = ({ config, size = 'medium' }: { config: EventLabelConfig; size?: 'medium' | 'large' }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gap: 'var(--fabric-space-gap-xxs)',
    }}
  >
    <AiEventIcon event={config.event} />
    <div>
      <Text as='span' size={size} weight={config.isBold ? 'bold' : undefined}>
        {config.text}
      </Text>
      {config.secondaryText && (
        <Text as='span' size={size}>
          {config.secondaryText}
        </Text>
      )}
    </div>
  </div>
);

export const AiEventBadgeWithReason = ({ config, reason }: { config: EventLabelConfig; reason?: string }) => {
  const reasonText = reason ? reason : config.reason;

  return (
    <div
      style={{
        display: 'grid',
        gap: 'var(--fabric-space-gap-xxs)',
        gridTemplateAreas: reasonText ? '"badge badge" ". reason"' : '"badge badge"',
        gridTemplateColumns: '16px 1fr',
      }}
    >
      <div style={{ gridArea: 'badge' }}>
        <AiEventBadge config={config} />
      </div>
      {reasonText && (
        <Truncated css={{ gridArea: 'reason' }} as={Text} size='small' color='subdued'>
          {reasonText}
        </Truncated>
      )}
    </div>
  );
};

export const AiEventIcon = ({ event }: { event: EventLabelConfig['event'] }) => (
  <div style={{ justifySelf: 'end', display: 'grid' }}>{getAiEventIcon({ event })}</div>
);
